import React, { createContext, useContext, useState, useCallback } from 'react';

const ProgressContext = createContext();

export const ProgressProvider = ({ children }) => {
  const [progressVersion, setProgressVersion] = useState(0);

  // Call this to signal that progress has changed
  const refreshProgress = useCallback(() => {
    setProgressVersion((v) => v + 1);
  }, []);

  return (
    <ProgressContext.Provider value={{ progressVersion, refreshProgress }}>
      {children}
    </ProgressContext.Provider>
  );
};

export const useProgress = () => useContext(ProgressContext); 